<template>
  <div class="container">
    <div
      class="modal modal-xl fade"
      id="moduleBoardModal"
      tabindex="-1"
      aria-hidden="true"
      @click="controlStore.cancelModulePlacement()"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
        @click.stop=""
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Add Component</h5>
            <div class="ms-auto">
              <label for="jsonUpload" class="btn btn-outline-primary btn-sm me-3">Import JSON Component</label>
              <input type="file" id="jsonUpload" accept=".json" style="display: none;" @change="importJSON" />
            </div>
            <button
              type="button"
              class="btn-close ms-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="controlStore.cancelModulePlacement()"
            ></button>
          </div>
          <div class="modal-body">
            <h6 class="text-muted mb-3 border-bottom pb-2">Built-in Components</h6>
            <div class="d-flex flex-wrap justify-content-evenly">
              <template v-for="(moduleCreator, index) in moduleStore.moduleFactory" :key="'built-' + index">
                <ComponentBoardItem
                  v-if="!moduleCreator.isUserComponent"
                  :moduleCreator="moduleCreator"
                  @click="onComponentClick(index)"
                />
              </template>
            </div>
            
            <h6 class="text-muted mt-4 mb-3 border-bottom pb-2">User Components (JSON)</h6>
            <div class="d-flex flex-wrap justify-content-evenly">
              <template v-for="(moduleCreator, index) in moduleStore.moduleFactory" :key="'user-' + index">
                <ComponentBoardItem
                  v-if="moduleCreator.isUserComponent"
                  :moduleCreator="moduleCreator"
                  @click="onComponentClick(index)"
                  @edit="editUserComponent(index)"
                  @delete="deleteUserComponent(index)"
                />
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ComponentPropertyBoard />
    <!-- Hidden button to trigger modal programmatically without conflict -->
    <button id="hidden-modal-trigger" class="d-none" data-bs-target="#modulePropBoardModal" data-bs-toggle="modal"></button>
  </div>
</template>
<script>
import { useControlStore } from "@/stores/control";
import { useMoudleStore } from "@/stores/module";
import { defineComponent } from "vue";
import ComponentBoardItem from "./ComponentBoardItem.vue";
import ComponentPropertyBoard from "./ComponentPropertyBoard.vue";
import UserComponentCreator from "@/library/modules/userComponentCreator";

export default defineComponent({
  components: {
    ComponentBoardItem,
    ComponentPropertyBoard
  },
  setup() {
    const moduleStore = useMoudleStore();
    const controlStore = useControlStore();
    
    const importJSON = (event) => {
      const file = event.target.files[0];
      if (!file) return;
      
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const jsonData = JSON.parse(e.target.result);
          // Only process module-template types
          if (jsonData.type !== "module-template") {
            alert("Invalid JSON: 'type' must be 'module-template'.");
            return;
          }
          const newCreator = new UserComponentCreator(jsonData);
          // Push to the factory list
          moduleStore.moduleFactory.push(newCreator);
          moduleStore.saveUserComponents();
          alert('User component imported successfully!');
        } catch (error) {
          console.error("Error parsing JSON component:", error);
          alert("Failed to parse JSON file. Please ensure it is valid.");
        }
      };
      reader.readAsText(file);
      // Reset input
      event.target.value = '';
    };

    const editUserComponent = (index) => {
      const creator = moduleStore.moduleFactory[index];
      const newName = prompt("Enter new name for component:", creator.moduleName);
      if (newName !== null && newName.trim() !== "") {
        creator.moduleName = newName.trim();
        creator.jsonData.name = newName.trim();
        moduleStore.saveUserComponents();
      }
    };

    const deleteUserComponent = (index) => {
      if (confirm("Are you sure you want to delete this custom component?")) {
        moduleStore.removeUserComponent(index);
      }
    };

    const onComponentClick = (index) => {
      moduleStore.selectModule(index);
      const trigger = document.getElementById('hidden-modal-trigger');
      if (trigger) {
        trigger.click();
      }
    };

    return {
      moduleStore,
      controlStore,
      importJSON,
      editUserComponent,
      deleteUserComponent,
      onComponentClick
    };
  }
});
</script>
